document.addEventListener('DOMContentLoaded', () => {
  const DURATION = 4500;
  const TAB_CLASS = 'tab';

  let autoRotation;

  const startRotation = () => {
    autoRotation = setInterval(activateNextTab, DURATION);
  };

  const stopRotation = () => {
    clearInterval(autoRotation);
  };

  const activateTab = (tab) => {
    const tabs = document.querySelectorAll(`.${TAB_CLASS}`);
    const index = Array.from(tabs).indexOf(tab);

    tabs.forEach((t) => t.classList.remove('active'));
    tabs[index].classList.add('active');
    $(tabs[index]).trigger('click');
  };

  const activateNextTab = () => {
    const tabs = document.querySelectorAll(`.${TAB_CLASS}`);
    const activeTab = document.querySelector(`.${TAB_CLASS}.active`);
    const activeIndex = Array.from(tabs).indexOf(activeTab);
    const nextIndex = (activeIndex + 1) % tabs.length;

    activateTab(tabs[nextIndex]);
  };

  const tabMouseEnterHandler = (event) => {
    const tab = event.target;
    stopRotation();
    activateTab(tab);
  };

  const tabMouseLeaveHandler = () => {
    startRotation();
  };

  const isSpecificDivVisible = () => {
    const specificDiv = document.querySelector('.section_showcase');
    return specificDiv && window.getComputedStyle(specificDiv).display !== 'none';
  };

  if (isSpecificDivVisible()) {
    const tabs = document.getElementsByClassName(TAB_CLASS);

    Array.from(tabs).forEach((tab) => {
      tab.addEventListener('mouseenter', tabMouseEnterHandler);
      tab.addEventListener('mouseleave', tabMouseLeaveHandler);
    });

    startRotation();

    const addClickListenerById = (id, url) => {
      const tab = document.getElementById(id);
      if (tab) {
        tab.addEventListener('click', () => {
          activateTab(tab);
          window.location.href = url;
        });
      }
    };

    addClickListenerById('tab-1', '/features/receipt-scanner.html');
    addClickListenerById('tab-2', '/features/expense-management.html');
    addClickListenerById('tab-3', '/features/mileage-tracker.html');
  }
});
